import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Pie } from 'react-chartjs-2'
import { AvForm, AvInput } from 'availity-reactstrap-validation'
import { jenisbarangFetchAll } from '../../actions/jenisbarangAction'
import { orderPerJenisPrioritas } from '../../actions/dashboardAction'
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'

let isDefaultJenisBarang = false
let isDefaultTahun = false

class OrderPerJenisPrioritas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      jenis_barang: '',
      jenis_barang_label: '',
      tahun: '',
      date_start: '',
      date_end: '',
    }

    this.selectJenisBarang = this.selectJenisBarang.bind(this)
    this.selectTahun = this.selectTahun.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    this.props.orderPerJenisPrioritas()
    this.props.jenisbarangFetchAll()
  }

  componentWillUnmount() {
    isDefaultJenisBarang = false
    isDefaultTahun = false
  }

  selectJenisBarang(opt) {
    if (opt) {
      this.setState({
        jenis_barang: opt.value,
        jenis_barang_label: opt.label
      })
    } else {
      this.setState({
        jenis_barang: '',
        jenis_barang_label: ''
      })
    }
  }

  selectTahun(opt) {
    if (opt) {
      this.setState({ tahun: opt.value })
    } else {
      this.setState({ tahun: '' })
    }
  }

  handleFilter(event, values) {
    if (this.state.jenis_barang) {
      values.jenis_barang = this.state.jenis_barang
      isDefaultJenisBarang = true
    } else {
      delete values.jenis_barang
      isDefaultJenisBarang = false
    }

    if (this.state.tahun) {
      values.tahun = this.state.tahun
      isDefaultTahun = true
    } else {
      delete values.tahun
      isDefaultTahun = false
    }

    this.setState({
      date_start: values.date_start,
      date_end: values.date_end
    })

    values.length = this.state.perPage

    this.props.orderPerJenisPrioritas(values)
  }

  renderData() {
    if (this.props.orderPerJenisPrioritasIsSuccess) {
      let defaultValues = {
        jenis_barang: this.state.jenis_barang,
        jenis_barang_label: this.state.jenis_barang_label,
        tahun: this.state.tahun,
        date_start: this.state.date_start,
        date_end: this.state.date_end,
      }

      const { tahun } = this.state.tahun
      const defaultValueTahun = { label: defaultValues.tahun, value: defaultValues.tahun }

      let orderPerJenisPrioritasData = this.props.orderPerJenisPrioritasData.report
      let labels = []
      let data = []

      orderPerJenisPrioritasData.forEach(val => {
        let arrLabel = val.jenis_barang
        let arrData = val.jml_order

        labels.push(arrLabel)
        data.push(arrData)
      })

      const pie_prioritas = {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#96c54c',
            '#ff9955',
            '#7f83c3',

          ],
          hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#96c54c',
            '#ff9955',
            '#7f83c3',
          ],
        }],
      }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Total Order Per Jenis Prioritas Periode</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  
                  <Col md="6">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Dari</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="date" name="date_start" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Sampai</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="date" name="date_end" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Select name="tahun"
                        value={tahun}
                        isClearable
                        placeholder="Tahun..."
                        defaultValue={isDefaultTahun ? defaultValueTahun : false}
                        onChange={this.selectTahun}
                        options={this.props.orderPerJenisPrioritasData.tahun}
                        id="tahun"
                        inputId="input_tahun"
                        instanceId="instance_tahun" />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="align-self-end">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1"><i className="fa fa-search"></i><span>Proses </span></Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody>
              <div className="chart-wrapper">
                <Pie data={pie_prioritas} />
              </div>
            </CardBody>
          </Card>
        </div>
      )
    }
  }

  render() {
    if (this.props.orderPerJenisPrioritasIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.orderPerJenisPrioritasHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }
}

OrderPerJenisPrioritas.propTypes = {
  orderPerJenisPrioritasIsSuccess: PropTypes.bool.isRequired,
  orderPerJenisPrioritasHasError: PropTypes.bool.isRequired,
  orderPerJenisPrioritasIsLoading: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  return {
    orderPerJenisPrioritasData: state.dashboard.orderPerJenisPrioritasData,
    orderPerJenisPrioritasIsSuccess: state.dashboard.orderPerJenisPrioritasSuccess,
    orderPerJenisPrioritasHasError: state.dashboard.orderPerJenisPrioritasError,
    orderPerJenisPrioritasIsLoading: state.dashboard.orderPerJenisPrioritasLoading,

    jenisbarangIsSuccess: state.jenisbarangs.jenisbarangGetSuccess,
    jenisbarangHasError: state.jenisbarangs.jenisbarangGetError,
    jenisbarangIsLoading: state.jenisbarangs.jenisbarangGetLoading,
    jenisbarang: state.jenisbarangs.jenisbarangs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    orderPerJenisPrioritas: (data) => dispatch(orderPerJenisPrioritas(data)),
    jenisbarangFetchAll: () => dispatch(jenisbarangFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderPerJenisPrioritas)